import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/design-system.css';
import './index.css';
import './i18n';
import App from './App';
import axios from 'axios';

// Налаштування базового URL для axios з .env файлу
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// Додавання інтерцептора для додавання токена авторизації
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>
);